import axios from "axios";
import api from "../api";
import store from "@/store";
import filter_service from "./filter-service";

function read(params) {
  let paginate = params.with_pagination ? { paginate: true } : {};
  let filter_params = filter_service.filter_params(params);
  return new Promise((resolve, reject) => {
    axios.get(`${api.products}${filter_params}`).then((response) => {
      if (params.with_pagination) {
        resolve({
          products: { ...paginate, ...response.data },
        });
      } else {
        resolve({
          products: response.data,
        });
      }
    });
  });
}

function get(id) {
  return new Promise((resolve, reject) => {
    axios.get(`${api.products}/${id}/configs`).then((response) => {
      resolve({
        product: response.data,
      });
    });
  });
}

function create(params) {
  return new Promise((resolve, reject) => {
    axios
      .post(api.products, params.product)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function update(params) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.products}/${params.id}`, params.product)
      .then(async (response) => {
        resolve({
          product: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function destroy(id) {
  return new Promise(async (resolve, reject) => {
    axios
      .delete(`${api.products}/${id}`)
      .then((response) => {
        resolve({
          product: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getProductByCategoryId(params, id) {
  let paginate = params.with_pagination ? { paginate: true } : {};
  let filter_params = filter_service.filter_params(params);
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.products}/${filter_params}`, params)
      .then((response) => {
        if (params.with_pagination) {
          let formatted_response = {
            ...response.data,
            data: response.data.data.map((product) => {
              return {
                ...product,
                formatted_suppliers: product.suppliers
                  .map((supplier) => {
                    return supplier.nickname;
                  })
                  .join(" | "),
                formatted_price: product.suppliers
                  .map((supplier) => {
                    return supplier.pivot.price;
                  })
                  .join(" | "),
                formatted_full_price: product.suppliers
                  .map((supplier) => {
                    return supplier.pivot.full_price;
                  })
                  .join(" | "),
                formatted_stock: product.suppliers
                  .map((supplier) => {
                    return supplier.pivot.stock;
                  })
                  .join(" | "),
                formatted_supply_date: product.suppliers
                  .map((supplier) => {
                    return supplier.pivot.supply_date ?? "Não informado";
                  })
                  .join(" | "),
              };
            }),
          };
          resolve({ ...paginate, ...formatted_response });
        } else {
          resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function attachFiles(params) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.products}/${params.product_id}/files`, params.files, {
        transformRequest: (data, headers) => {
          delete headers.common["Content-type"];
          return data;
        },
      })
      .then((response) => {
        resolve({
          product: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getFiles(product_id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.products}/${product_id}/files`)
      .then((response) => {
        resolve({
          files: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function removeFile(params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${api.products}/${params.product_id}/files/${params.file_id}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function exportCsv() {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.products}/export/csv`, { responseType: "blob" })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function importCsv(params) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.products}/import/csv`, params, {
        transformRequest: (data, headers) => {
          delete headers.common["Content-type"];
          return data;
        },
      })
      .then((response) => {
        store.dispatch("alerts/success", "Dados importados com sucesso!");
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function setMarginToProductCategory(params) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.base}/margin/${params.category_id}`, {
        margin: params.margin,
      })
      .then((response) => {
        store.dispatch("alerts/success", "Margem atualizada com sucesso!");
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function createProductDimensions(id, dimensions) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.products}/${id}/dimensions`, {
        ...dimensions,
      })
      .then((response) => {
        store.dispatch(
          "alerts/success",
          "Dimensões do produto criadas com sucesso!"
        );
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateProductDimensions(id, dimensions) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.products}/${id}/dimensions`, {
        ...dimensions,
      })
      .then((response) => {
        store.dispatch(
          "alerts/success",
          "Dimensões do produto atualizadas com sucesso!"
        );
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getDimensionsById(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.products}/${id}/dimensions`)
      .then((response) => {
        if (response.data.length === 0) {
          resolve({ width: 0, length: 0, weight: 0, thickness: 0, volume: 0 });
        }
        let responseFormatted = response.data.pop();
        resolve({
          width: responseFormatted.width ?? 0,
          length: responseFormatted.length ?? 0,
          weight: responseFormatted.weight ?? 0,
          thickness: responseFormatted.thickness ?? 0,
          volume: responseFormatted.volume ?? 0,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}


export default {
  read,
  get,
  create,
  destroy,
  getProductByCategoryId,
  update,
  attachFiles,
  getFiles,
  removeFile,
  exportCsv,
  importCsv,
  setMarginToProductCategory,
  createProductDimensions,
  updateProductDimensions,
  getDimensionsById
};
